import { ScheduleType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { restApiClient } from '@/datasources';

interface GetAvailableHoursProps {
  id: string;
  date: string;
}

export type RescheduleAvailableHour = {
  id: string;
  date: string;
  start: string;
  end: string;
  scheduleType: ScheduleType;
  status: string;
  timeZone: string;
  timeOffset: string;
};

export type RescheduleAvailableHourResponse = Record<
  ScheduleType.ARRIVAL_ORDER | ScheduleType.SCHEDULED | ScheduleType.LABORATORIAL,
  RescheduleAvailableHour[]
>;

export const getAvailableHours = async ({ id, date }: GetAvailableHoursProps) => {
  const { data } = await restApiClient.get<RescheduleAvailableHour[]>(
    `/online/customers/appointments/${id}/reschedule-available-hours/`,
    { date },
  );

  const formatedByScheduleType = data.reduce(
    (acc, item) => {
      const { scheduleType } = item;
      if ([ScheduleType.ARRIVAL_ORDER, ScheduleType.LABORATORIAL, ScheduleType.SCHEDULED].includes(scheduleType)) {
        if (scheduleType in acc) {
          acc[scheduleType as keyof RescheduleAvailableHourResponse].push(item);
        }
      }
      return acc;
    },
    {
      [ScheduleType.ARRIVAL_ORDER]: [],
      [ScheduleType.SCHEDULED]: [],
      [ScheduleType.LABORATORIAL]: [],
    } as RescheduleAvailableHourResponse,
  );
  return formatedByScheduleType;
};
